import { styled } from '@mui/material';
import { FlexRow as _FlexRow } from './ManagementPage.styled';

export const FlexRow = styled(_FlexRow)`
  justify-content: flex-end;
`;
